import styled, { css } from "styled-components";

export const MaxHeightImg = styled.img`
  width: auto;
  max-height: calc(${({ theme }) => theme.icon.size.xs} / 1.3);
  margin: 0 calc(${({ theme }) => theme.space.lg} / 2);

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 ${({ theme }) => theme.space.md};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-height: ${({ theme }) => theme.icon.size.sm};
  }
`;

export const ContainerWithSidelights = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  background: transparent;
`;

export const ContainerWithBackground = styled.div`
  height: 20px;
  width: 100%;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.senary.base} 0%,
    ${({ theme }) => theme.colors.primary.base} 100%
  );
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 40px;
  }
`;

export const AppSwitchOption = styled.button`
  border: none;
  background: ${({ $shouldHaveGradientBg }) =>
    $shouldHaveGradientBg ? "transparent" : "rgb(203, 223, 226)"};

  &:hover {
    ${({ $shouldHaveGradientBg }) =>
      !$shouldHaveGradientBg &&
      css`
        cursor: pointer;
      `}
  }
`;

export const Sidelight = styled.div`
  ${({ $isLeftSidelight }) =>
    $isLeftSidelight
      ? css`
          width: calc(50vw - 720px);
        `
      : css`
          flex-grow: 100;
        `};

  background: rgb(224, 235, 237);
`;
